// extracted by mini-css-extract-plugin
export default {"no_image_icon_wrapper":"FloorPlanNoImageIcon_no_image_icon_wrapper__Jswcs","no_image_icon":"FloorPlanNoImageIcon_no_image_icon__kiIXY"};